(() => {
  if (window.MarqSignup) return;

  const safeReturnTo = value => {
    try {
      const url = new URL(value || '/', location.origin);
      if (url.origin !== location.origin || /^(?:\/account(?:\/|$)|\/customer_authentication(?:\/|$)|\/pages\/sign-up(?:\/|$))/i.test(url.pathname)) return '/';
      return url.pathname + url.search + url.hash;
    } catch (_) {
      return '/';
    }
  };

  const returnTo = () => {
    const params = new URLSearchParams(location.search);
    return safeReturnTo(params.get('signup_return_to') || params.get('return_to') || params.get('checkout_url'));
  };

  const loginURL = email => {
    const url = new URL('/customer_authentication/login', location.origin);
    url.searchParams.set('return_to', returnTo());
    if (email) url.searchParams.set('login_hint', email);
    return url.href;
  };

  const updateLink = link => {
    if (link.matches('[data-signup-sign-in]')) {
      link.href = loginURL();
      return;
    }
    if (link.matches('[data-signup-continue]')) return;
    let url;
    try { url = new URL(link.href); } catch (_) { return; }
    const signedIn = document.body.classList.contains('customer-logged-in');
    if (signedIn && url.origin === location.origin && /^\/pages\/sign-up\/?$/.test(url.pathname)) {
      link.href = '/account';
      return;
    }
    // Shopify's new accounts render these theme links with authentication or
    // account-domain URLs; their IDs still identify the signed-out entry points.
    const accountEntry = link.matches('#customer_login_link, .customer_login_link, #customer_register_link');
    if (!accountEntry && (url.origin !== location.origin || !/^\/account\/(?:login|register)\/?$/.test(url.pathname))) return;
    if (signedIn) {
      link.href = '/account';
      return;
    }
    const destination = new URL('/pages/sign-up', location.origin);
    const original = url.searchParams.get('signup_return_to') || url.searchParams.get('return_to') || url.searchParams.get('checkout_url');
    destination.searchParams.set('signup_return_to', safeReturnTo(original || (location.pathname === '/pages/sign-up' ? returnTo() : location.href)));
    destination.hash = url.hash;
    link.href = destination.href;
  };

  // Inline Shopify Forms treats return_to as its own post-submit redirect.
  // Reserve it for authentication, and migrate existing signup links before
  // a successful form submission can bypass sign-in.
  if (/^\/pages\/(?:sign-up|trade-account)\/?$/.test(location.pathname)) {
    const url = new URL(location.href);
    if (url.searchParams.has('return_to')) {
      url.searchParams.set('signup_return_to', returnTo());
      url.searchParams.delete('return_to');
      history.replaceState(history.state, '', url.href);
    }
  }

  window.MarqSignup = {safeReturnTo, returnTo, loginURL};
  document.querySelectorAll('a[href]').forEach(updateLink);
  // Also cover links added later by the menu or product components.
  document.addEventListener('click', event => {
    const link = event.target.closest?.('a[href]');
    if (link) updateLink(link);
  }, true);
})();
